import { render, staticRenderFns } from "./fwsed-firm-detail.vue?vue&type=template&id=0af4b96a&scoped=true&"
import script from "./fwsed-firm-detail.vue?vue&type=script&lang=js&"
export * from "./fwsed-firm-detail.vue?vue&type=script&lang=js&"
import style0 from "./fwsed-firm-detail.vue?vue&type=style&index=0&id=0af4b96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4b96a",
  null
  
)

export default component.exports